// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".velocity-verification-Pannable-container {\n  overflow: auto;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "velocity-verification-Pannable-container"
};
module.exports = exports;
